var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sa-page-layout',[_c('template',{slot:"table-header"},[_c('h3',[_vm._v("Codici IcdIX")])]),_c('template',{slot:"table-body"},[_c('div',{staticClass:"sa-tab-scroll"},[_c('codici-icd-ix-list-component')],1)])],2)}
var staticRenderFns = []

export { render, staticRenderFns }